import Api from "../apiService";

class tripRoutesApi {
  index(companyId, tripId) {
    return Api.getRequest(
      `companies/${companyId}/trips/${tripId}/route/legs`,
      {},
      Api.authHeaders()
    );
  }

  summariesIndex(companyId, tripId) {
    return Api.getRequest(
      `companies/${companyId}/trips/${tripId}/route/summaries`,
      {},
      Api.authHeaders()
    );
  }

  generateSummaries(companyId, tripId) {
    return Api.postRequest(
      `companies/${companyId}/trips/${tripId}/route/summaries`,
      {},
      Api.authHeaders()
    );
  }
}

export default new tripRoutesApi();
